class APIS {
	apis() {
		return {
			// List campaigns awaiting approval, grouped by client.
			// payload: { status: 'pending' | 'approved' | 'rejected', page, limit }
			// response: data.data.data.clients[] (each with account_manager + campaigns[])
			list: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/template/campaign/approval/list'
			},
			// Approve a campaign.
			// payload: { campaign_id, internal_sub_category }
			approve: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/template/campaign/approval/approve'
			},
			// Reject a campaign.
			// payload: { campaign_id, notes }
			reject: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/template/campaign/approval/reject'
			}
		};
	}
}

export default new APIS();
